import { render } from "./settlementDetails.vue?vue&type=template&id=3005c287&scoped=true"
import script from "./settlementDetails.vue?vue&type=script&lang=js"
export * from "./settlementDetails.vue?vue&type=script&lang=js"

import "./settlementDetails.vue?vue&type=style&index=0&id=3005c287&rel=stylesheet%2Fscss&lang=scss&scoped=true"

import exportComponent from "E:\\aliPro\\platformpro\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3005c287"]])

export default __exports__